export default __webpack_public_path__ + "static/media/677.c9f67c19.png";